// extracted by mini-css-extract-plugin
export default {"FusionWear":"FusionWear_FusionWear__HW8nK","FusionWearWrap":"FusionWear_FusionWearWrap__sNSOI"};